import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import useElement from "backend/hooks/elements/useElement";
import ToolbarWithHeading from "./ToolbarWithHeading";

const ToolbarWithMeasureName = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading } = useElement(ctx.elementId);
  return <ToolbarWithHeading>{data ? data.name : ""}</ToolbarWithHeading>;
};

export default ToolbarWithMeasureName;
